import firebase from 'firebase/app'
import 'firebase/functions'

const firebaseConfig = {
  apiKey: 'AIzaSyBll5kwlm2iikRdDI3N3JC9Lk9Mz46V2VU',
  authDomain: 'mdonline-9d2f9.firebaseapp.com',
  projectId: 'mdonline-9d2f9',
  storageBucket: 'mdonline-9d2f9.firebasestorage.app',
  messagingSenderId: '56564658623',
  appId: '1:56564658623:web:ff761b740d91b89c2c310a',
}

firebase.initializeApp(firebaseConfig)

const functions = firebase.app().functions('europe-west3')

export { firebase, functions }
